import { IS_LOGIN_WIDGET_ENABLED_PATH, IS_VIEWS_COUNT_ENABLED_PATH, IS_LIST_HASHTAGS_ENABLED_PATH, IS_SHOW_SUBCATEGORIES_ENABLED_PATH, IS_BADGES_ENABLED_PATH, IS_SIMILAR_POSTS_ENABLED_PATH, IS_FOOTER_POSTS_ENABLED_PATH, IS_HEADER_ENABLED_PATH, IS_MAIN_PAGE_HEADER_ENABLED_PATH, MAIN_PAGE_HEADER_HEIGHT_PATH, MAIN_PAGE_TEXT_ALIGNMENT_PATH, HEADER_HEIGHT_PATH, CATEGORY_TEXT_ALIGNMENT_PATH, TEXT_ALIGNMENT_CENTER, } from '../constants';
import { getAppSettingsValue } from '../store/app-settings/app-settings-selectors';
import { isMemberAreaActive } from './member-area-selectors';
export var getIsShowSubcategoriesEnabled = function (_a) {
    var _b = _a === void 0 ? {} : _a, getIsMobile = _b.getIsMobile;
    return function (state, style, _a) {
        var _b = _a === void 0 ? {} : _a, getMobileSettingsValue = _b.getMobileSettingsValue;
        return getAppSettingsValue({
            style: style,
            key: IS_SHOW_SUBCATEGORIES_ENABLED_PATH,
            fallback: false,
            isMobileSettingsValue: getIsMobile ? getIsMobile(state) : getMobileSettingsValue,
        });
    };
};
export var getIsLoginWidgetEnabled = function (_a) {
    var _b = _a === void 0 ? {} : _a, getIsMobile = _b.getIsMobile;
    return function (state, style, _a) {
        var _b = _a === void 0 ? {} : _a, getMobileSettingsValue = _b.getMobileSettingsValue;
        return getAppSettingsValue({
            style: style,
            key: IS_LOGIN_WIDGET_ENABLED_PATH,
            fallback: !isMemberAreaActive(state),
            isMobileSettingsValue: getIsMobile ? getIsMobile(state) : getMobileSettingsValue,
        });
    };
};
export var getIsViewsCountEnabled = function (_a) {
    var _b = _a === void 0 ? {} : _a, getIsMobile = _b.getIsMobile;
    return function (state, style, _a) {
        var _b = _a === void 0 ? {} : _a, getMobileSettingsValue = _b.getMobileSettingsValue;
        return getAppSettingsValue({
            style: style,
            key: IS_VIEWS_COUNT_ENABLED_PATH,
            fallback: true,
            isMobileSettingsValue: getIsMobile ? getIsMobile(state) : getMobileSettingsValue,
        });
    };
};
export var getIsListHashtagsEnabled = function (_a) {
    var _b = _a === void 0 ? {} : _a, getIsMobile = _b.getIsMobile;
    return function (state, style, _a) {
        var _b = _a === void 0 ? {} : _a, getMobileSettingsValue = _b.getMobileSettingsValue;
        return getAppSettingsValue({
            style: style,
            key: IS_LIST_HASHTAGS_ENABLED_PATH,
            fallback: true,
            isMobileSettingsValue: getIsMobile ? getIsMobile(state) : getMobileSettingsValue,
        });
    };
};
export var getIsBadgesEnabled = function (_a) {
    var _b = _a === void 0 ? {} : _a, getIsMobile = _b.getIsMobile;
    return function (state, style, _a) {
        var _b = _a === void 0 ? {} : _a, getMobileSettingsValue = _b.getMobileSettingsValue;
        return getAppSettingsValue({
            style: style,
            key: IS_BADGES_ENABLED_PATH,
            fallback: true,
            isMobileSettingsValue: getIsMobile ? getIsMobile(state) : getMobileSettingsValue,
        });
    };
};
export var getIsSimilarPostsEnabled = function (_a) {
    var _b = _a === void 0 ? {} : _a, getIsMobile = _b.getIsMobile;
    return function (state, style, _a) {
        var _b = _a === void 0 ? {} : _a, getMobileSettingsValue = _b.getMobileSettingsValue;
        return getAppSettingsValue({
            style: style,
            key: IS_SIMILAR_POSTS_ENABLED_PATH,
            fallback: true,
            isMobileSettingsValue: getIsMobile ? getIsMobile(state) : getMobileSettingsValue,
        });
    };
};
export var getIsFooterPostsEnabled = function (_a) {
    var _b = _a === void 0 ? {} : _a, getIsMobile = _b.getIsMobile;
    return function (state, style, _a) {
        var _b = _a === void 0 ? {} : _a, getMobileSettingsValue = _b.getMobileSettingsValue;
        return getAppSettingsValue({
            style: style,
            key: IS_FOOTER_POSTS_ENABLED_PATH,
            fallback: true,
            isMobileSettingsValue: getIsMobile ? getIsMobile(state) : getMobileSettingsValue,
        });
    };
};
export var getIsMainPageHeaderEnabled = function (_a) {
    var _b = _a === void 0 ? {} : _a, getIsMobile = _b.getIsMobile;
    return function (state, style, _a) {
        var _b = _a === void 0 ? {} : _a, getMobileSettingsValue = _b.getMobileSettingsValue;
        return getAppSettingsValue({
            style: style,
            key: IS_MAIN_PAGE_HEADER_ENABLED_PATH,
            fallback: true,
            isMobileSettingsValue: getIsMobile ? getIsMobile(state) : getMobileSettingsValue,
        });
    };
};
export var getIsHeaderEnabled = function (_a) {
    var _b = _a === void 0 ? {} : _a, getIsMobile = _b.getIsMobile;
    return function (state, style, _a) {
        var _b = _a === void 0 ? {} : _a, getMobileSettingsValue = _b.getMobileSettingsValue;
        return getAppSettingsValue({
            style: style,
            key: IS_HEADER_ENABLED_PATH,
            fallback: true,
            isMobileSettingsValue: getIsMobile ? getIsMobile(state) : getMobileSettingsValue,
        });
    };
};
export var getHeaderHeight = function (_a) {
    var _b = _a === void 0 ? {} : _a, getIsMobile = _b.getIsMobile;
    return function (state, style, _a) {
        var _b = _a === void 0 ? {} : _a, getMobileSettingsValue = _b.getMobileSettingsValue;
        var isMobile = getIsMobile && getIsMobile(state);
        return getAppSettingsValue({
            style: style,
            key: HEADER_HEIGHT_PATH,
            fallback: isMobile ? 100 : 250,
            isMobileSettingsValue: isMobile || getMobileSettingsValue,
            useDesktopFallback: false,
        });
    };
};
export var getMainPageHeaderHeight = function (_a) {
    var _b = _a === void 0 ? {} : _a, getIsMobile = _b.getIsMobile;
    return function (state, style, _a) {
        var _b = _a === void 0 ? {} : _a, getMobileSettingsValue = _b.getMobileSettingsValue;
        return getAppSettingsValue({
            style: style,
            key: MAIN_PAGE_HEADER_HEIGHT_PATH,
            fallback: getHeaderHeight({ getIsMobile: getIsMobile })(state, style),
            isMobileSettingsValue: getIsMobile ? getIsMobile(state) : getMobileSettingsValue,
            useDesktopFallback: false,
        });
    };
};
export var getCategoryTextAlignment = function (_a) {
    var _b = _a === void 0 ? {} : _a, getIsMobile = _b.getIsMobile;
    return function (state, style, _a) {
        var _b = _a === void 0 ? {} : _a, getMobileSettingsValue = _b.getMobileSettingsValue;
        return getAppSettingsValue({
            style: style,
            key: CATEGORY_TEXT_ALIGNMENT_PATH,
            fallback: TEXT_ALIGNMENT_CENTER,
            isMobileSettingsValue: getIsMobile ? getIsMobile(state) : getMobileSettingsValue,
        });
    };
};
export var getMainPageHeaderTextAlignment = function (_a) {
    var _b = _a === void 0 ? {} : _a, getIsMobile = _b.getIsMobile;
    return function (state, style, _a) {
        var _b = _a === void 0 ? {} : _a, getMobileSettingsValue = _b.getMobileSettingsValue;
        return getAppSettingsValue({
            style: style,
            key: MAIN_PAGE_TEXT_ALIGNMENT_PATH,
            fallback: getCategoryTextAlignment({ getIsMobile: getIsMobile })(state, style),
            isMobileSettingsValue: getIsMobile ? getIsMobile(state) : getMobileSettingsValue,
        });
    };
};
//# sourceMappingURL=app-settings-selectors.js.map